var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 8.25002H14.6667M7.33333 11.9167H12.8333M16.5 3.66669C17.2293 3.66669 17.9288 3.95642 18.4445 4.47214C18.9603 4.98787 19.25 5.68734 19.25 6.41669V13.75C19.25 14.4794 18.9603 15.1788 18.4445 15.6946C17.9288 16.2103 17.2293 16.5 16.5 16.5H11.9167L7.33333 19.25V16.5H5.5C4.77065 16.5 4.07118 16.2103 3.55546 15.6946C3.03973 15.1788 2.75 14.4794 2.75 13.75V6.41669C2.75 5.68734 3.03973 4.98787 3.55546 4.47214C4.07118 3.95642 4.77065 3.66669 5.5 3.66669H16.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagerIcon);
export default __webpack_public_path__ + "static/media/messager-icon.b1718f5609a4dd0e84e70d3e20f0bb75.svg";
export { ForwardRef as ReactComponent };